(function () {
  /* Both the collection hero and the product grid ask for this file, so a
     collection page carries two tags and the browser runs each of them. One
     pass is all that is wanted: everything below binds listeners on `document`,
     and a second copy would bind them again and fire each handler twice. The
     `shopify:section:load` listener the first copy registers still re-inits a
     re-rendered section for the theme editor, so nothing is lost by returning.
     Same pattern as assets/mt-blog-hub.js. */
  if (window.__mtCollectionReady) return;
  window.__mtCollectionReady = true;

  /* Favourites are owned by assets/wishlist.js — it holds the storage key,
     handles heart clicks for the whole document and keeps the header count in
     step. This section only needs to re-sync buttons it renders itself. */
  function syncFavoriteButtons(root) {
    if (window.MTWishlist) window.MTWishlist.syncButtons(root);
  }

  /* Hero typewriter — the site-wide `[data-typewriter]` + `data-text`
     contract, so a collection hero types, blinks and finishes exactly like the
     search, kits, blog and collection-list heroes. Byte-for-byte the handler in
     assets/mt-blog-hub.js and the inline copy in sections/mt-search.liquid: "|"
     is a line break and a {braced} run becomes .mt-tw-em. The `data-tw-on` flag
     is shared with those copies, so whichever file runs first on a page wires
     each heading once and the others skip it.

     This replaced a local version that only swapped textContent — no caret, its
     own speed, and it typed the catalog page's heading alone. */
  function initTypewriter(root) {
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function renderRuns(host, text) {
      var target = host;
      for (var i = 0; i < text.length; i++) {
        var ch = text[i];
        if (ch === '|') {
          host.appendChild(document.createElement('br'));
        } else if (ch === '{') {
          var em = document.createElement('span');
          em.className = 'mt-tw-em';
          host.appendChild(em);
          target = em;
        } else if (ch === '}') {
          target = host;
        } else {
          target.appendChild(document.createTextNode(ch));
        }
      }
    }

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-typewriter]:not([data-tw-on])'),
      function (el) {
        el.setAttribute('data-tw-on', '1');

        var text = el.getAttribute('data-text') || el.textContent;
        var speed = parseInt(el.getAttribute('data-speed') || '46', 10);
        var initial = parseInt(el.getAttribute('data-initial-delay') || '250', 10);

        /* Reduced motion: show the finished markup, never type. */
        if (reduceMotion) {
          el.innerHTML = '';
          var flat = document.createElement('span');
          flat.className = 'mt-tw-content';
          renderRuns(flat, text);
          el.appendChild(flat);
          return;
        }

        el.innerHTML = '';
        var span = document.createElement('span');
        span.className = 'mt-tw-content';
        var cursor = document.createElement('span');
        cursor.className = 'mt-tw-cursor';
        cursor.textContent = '|';
        el.appendChild(span);
        el.appendChild(cursor);

        var i = 0;
        var target = span;

        function tick() {
          if (i < text.length) {
            var ch = text[i++];
            if (ch === '|') {
              span.appendChild(document.createElement('br'));
            } else if (ch === '{') {
              var em = document.createElement('span');
              em.className = 'mt-tw-em';
              span.appendChild(em);
              target = em;
            } else if (ch === '}') {
              target = span;
            } else {
              target.appendChild(document.createTextNode(ch));
            }
            setTimeout(tick, speed);
          } else {
            /* Short beat so the caret reads as "finished" rather than cutting
               out mid-stroke, then it goes. */
            setTimeout(function () {
              cursor.classList.add('is-done');
              /* The fade is 0.4s (the .is-done rule in
                 assets/component-collection-hero.css); once it is done the caret
                 leaves the DOM rather than sitting at opacity 0 — it is an
                 inline-block with a left margin, so invisible is not gone. A
                 timer rather than animationend, so it is still removed if the
                 stylesheet never applied. */
              setTimeout(function () {
                if (cursor.parentNode) cursor.parentNode.removeChild(cursor);
              }, 450);
            }, 250);
          }
        }

        setTimeout(tick, initial);
      }
    );
  }

  document.addEventListener('click', function (event) {
    /* Card links go straight to the product page. Heart clicks are handled
       globally by assets/wishlist.js, which stops them from reaching the link
       they sit inside. */
    var sortOption = event.target.closest('[data-sort-value]');
    if (sortOption) {
      var form = sortOption.closest('form');
      var select = form && form.querySelector('#SortBy');
      if (!select) return;

      select.value = sortOption.dataset.sortValue;
      var sortLabel = form.querySelector('[data-sort-label]');
      if (sortLabel) sortLabel.textContent = sortOption.dataset.sortName;
      form.querySelectorAll('[data-sort-value]').forEach(function (option) {
        option.classList.toggle('is-selected', option === sortOption);
      });
      sortOption.closest('details').removeAttribute('open');
      select.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    document.querySelectorAll('#main-collection-filters .mt-fsel-disclosure[open]').forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('change', function (event) {
    var checkbox = event.target;
    if (!checkbox.matches('.mt-brand-options input[type="checkbox"]') || !checkbox.checked) return;

    var fieldset = checkbox.closest('.mt-brand-options');
    fieldset.querySelectorAll('input[type="checkbox"]').forEach(function (sibling) {
      if (sibling !== checkbox) sibling.checked = false;
    });

    var details = checkbox.closest('details');
    if (details) details.removeAttribute('open');
  });

  document.addEventListener('pointermove', function (event) {
    var card = event.target.closest('.mt-catalog-card');
    if (!card || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var bounds = card.getBoundingClientRect();
    var x = (event.clientX - bounds.left) / bounds.width;
    var y = (event.clientY - bounds.top) / bounds.height;
    card.style.setProperty('--rx', ((0.5 - y) * 5).toFixed(2) + 'deg');
    card.style.setProperty('--ry', ((x - 0.5) * 5).toFixed(2) + 'deg');
    card.style.setProperty('--glow-x', (x * 100).toFixed(1) + '%');
    card.style.setProperty('--glow-y', (y * 100).toFixed(1) + '%');
  });

  document.addEventListener('pointerout', function (event) {
    var card = event.target.closest('.mt-catalog-card');
    if (!card || card.contains(event.relatedTarget)) return;
    card.style.setProperty('--rx', '0deg');
    card.style.setProperty('--ry', '0deg');
  });

  function initializeCatalog() {
    initTypewriter(document);
    syncFavoriteButtons(document);

    var grid = document.getElementById('ProductGridContainer');
    if (grid && !grid.dataset.catalogObserver) {
      grid.dataset.catalogObserver = 'true';
      new MutationObserver(function () {
        syncFavoriteButtons(grid);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCatalog);
  } else {
    initializeCatalog();
  }

  document.addEventListener('shopify:section:load', initializeCatalog);
})();
